'use strict';

var _ = require('lodash');
function ServiceManagementGridController($scope, constants, dataService, configurationService, $q, $timeout, fcrService) {
  $scope.gridId = constants.GRIDS.SERVICE_MANAGEMENT;
  $scope.isNotApplicableMessage = true;
  $scope.controlTypes = ['Availability', 'Authorization', 'Bookings'];
  $scope.controlType = $scope.controlTypes[0];
  $scope.onSelectFlights = function (selectedFlights) {
    $scope.isNotApplicableMessage = !isApplicable(selectedFlights);
    if ($scope.isNotApplicableMessage) {
      $scope.$broadcast('grid:clearAndLoadData:' + $scope.gridId);
      return;
    }
    $timeout(function () {
      $scope.$broadcast('grid:clearAndLoadData:' + $scope.gridId);
    }, 150);
  };
  $scope.reloadData = function () {
    if (!isApplicable($scope.selectedFlights)) {
      return $q.when([]);
    }
    return dataService.getData($scope.selectedFlights, $scope.controlType);
  };
  $scope.classColumnsSorter = function (columns) {
    var firstSelectedFlight = _.first($scope.selectedFlights);
    var fcrTag = fcrService.getClassGroupIndicesKey(firstSelectedFlight.flightDepartureDateMoment, firstSelectedFlight.leg);
    var leg = isApplicable($scope.selectedFlights) ? firstSelectedFlight.leg : undefined;
    var groupIndexes = configurationService.getClassGroupsByMarket(leg, fcrTag);
    var classesIndexes = configurationService.getClassIndexMapping(leg, fcrTag);
    return columns.sort(function (a, b) {
      // try to sort by class group first
      var v1 = groupIndexes.indexOf(a.title || a);
      var v2 = groupIndexes.indexOf(b.title || b);
      if (v1 !== -1 && v2 !== -1) {
        return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
      }

      // sort by class index otherwise
      var value1 = classesIndexes[a.title || a];
      var value2 = classesIndexes[b.title || b];
      return value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
    });
  };
  $scope.onPanel = function (ev, isExpanded) {
    if (isExpanded && isApplicable($scope.selectedFlights)) {
      $timeout(function () {
        $scope.$broadcast('grid:clearAndLoadData:' + $scope.gridId);
      }, 150);
    }
  };
  function isApplicable(selectedFlights) {
    return _(selectedFlights).groupBy('flightId').size() === 1;
  }
  $scope.updateInventoryControls = function (controlType) {
    $scope.controlType = controlType;
    $scope.$broadcast('grid:clearAndLoadData:' + $scope.gridId);
  };
}
ServiceManagementGridController.$inject = ['$scope', 'FlightManagementConstants', 'ServiceManagementDataService', 'ConfigurationService', '$q', '$timeout', 'FcrService'];
module.exports = ServiceManagementGridController;